<template>
    <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
      <feather-icon
        icon="Edit3Icon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="editRecord(params.data)"
        title="Edit"
      />
      <feather-icon
        icon="Trash2Icon"
        svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
        @click="confirmDeleteRecord(params.data)"
        title="Delete"
      />
    </div>
  </template>
  
  <script>
  import Swal from "sweetalert2";
  import { bus } from "../../../../main";
  // Mixins
  import commonMixin from '@/mixins/common'
  export default {
    name: "CellRendererActions",
    mixins: [commonMixin],
    data (){
      return {

      }
    },
    methods: {
      editRecord(data) {
        bus.$emit("editLocation", data);
      },
      confirmDeleteRecord(data) {
        const { value: text } = Swal.fire({
          title: "Do you want to Delete this location ?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecord(data);
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
      },
      deleteRecord(data) {
        
        data.IsPublished = false;
        bus.$emit("changeLocationStatus", data);
      },
    },
  };
  </script>
  